<template>
  <v-container class="ts-bigdata">
    <ts-date-picker @change="(v) => dateRange = v"/>
    <v-row class="ts-bigdata__chart-wrapper">
      <v-col>
        <ts-player-chart
            :unit-control.sync="chartUnit"
            :players="players"
            :records="selectedRecords"
        ></ts-player-chart>
      </v-col>
      <v-col cols="auto">
        <ts-ranking
            :players="players"
            :records="selectedFromRecordTable.length ? selectedFromRecordTable : totalRecords"
            @click:ranking-card="handleCardChange"
        ></ts-ranking>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="ts-bigdata__record-table-wrapper">
        <ts-record-table
            v-model="selectedFromRecordTable"
            selectable
            :players="players"
            :records="totalRecords"
        ></ts-record-table>
      </v-col>
    </v-row>
  </v-container>
</template>


<style lang="scss">
  .ts-bigdata__record-table-wrapper{
    flex-grow:1;
  }
</style>

<script>
import TsRanking from "../components/TsRanking";
import { getPlayers } from "../api/player";
import { getRecords } from "@/api/record";
import TsRecordTable from "@/components/TsRecordTable";
import TsPlayerChart from "@/components/TsPlayerChart";
import TsDatePicker from "../components/TsDatePicker";

export default {
    name: "Bigdata",
    components: {TsDatePicker, TsPlayerChart, TsRecordTable, TsRanking},
    props:{
      intent: Object
    },
    data: function () {
      return {
        chartUnit: 'hour',
        dateRange: [],
        players: [],
        totalRecords: [],
        selectedRecords: [],
        selectedFromRecordTable: [],
      }
    },
    watch: {
      dateRange: {
        deep: true,
        handler (val) {
          this.setProperChartUnit(val)
          this.getRecords()
        }
      }
    },
    mounted () {
      this.setProperChartUnit(this.dateRange)
      this.getPlayers()
      this.getRecords()
      this.$emit('update:picker',true)
    },
    methods: {
      setProperChartUnit(val){
        const diff = this.$day(val[1]).diff(this.$day(val[0]))
        this.chartUnit = 'month'
        if(val.length === 2){
          /*if(diff < 86400000 * 7 * 3) this.chartUnit = 'min'
          else */if(diff < 86400000 * 30 * 3) this.chartUnit = 'hour'
          else if(diff < 86400000 * 30 * 6) this.chartUnit = 'day'
        }
      },
      handleCardChange ( teamRecord ){
        this.selectedRecords = teamRecord
        // 1등 이미지
        if(teamRecord[0] && teamRecord[0].win &&  teamRecord[0].players[0] && teamRecord[0].players[0].meta){
          this.intent.background = teamRecord[0].players[0].meta.image
        }
      },
      getPlayers () {
        return getPlayers().then(data => (this.players = data))
      },
      getRecords () {
        return getRecords().then(data => {
          if( this.dateRange &&  this.dateRange.length === 2){
            const start = this.$day(this.dateRange[0])
            const end = this.$day(this.dateRange[1]).add(1,'day')
            data = data.filter(({date}) => {
              date = this.$day(date)
              return date.isBefore(end) && (date.isAfter(start) || date.isSame(start))
            })
          }

          this.totalRecords = data
          window._data = window._data || {}
          window._data.record = data
        })
      }

    }
  }
</script>
